import { createRouter, createWebHistory } from 'vue-router'
import { routerConstants } from '@/constants/routers/common'
import Index from '@/components/pages/common/questions/Index/index.vue'
import One from '@/components/pages/common/questions/One/index.vue'
import Two from '@/components/pages/common/questions/Two/index.vue'
import Three from '@/components/pages/common/questions/Three/index.vue'
import Four from '@/components/pages/common/questions/Four/index.vue'
import Five from '@//components/pages/common/questions/Five/index.vue'
import Result from '@/components/pages/common/questions/Result/index.vue'

const { PATH, ROUTE_NAME } = routerConstants.LOCATION

export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior() {
    return {
      top: 0,
    }
  },
  routes: [
    {
      path: PATH.QUESTIONS_INDEX,
      name: ROUTE_NAME.QUESTIONS_INDEX,
      component: Index,
    },
    {
      path: PATH.QUESTIONS_ONE,
      name: ROUTE_NAME.QUESTIONS_ONE,
      component: One,
    },
    {
      path: PATH.QUESTIONS_TWO,
      name: ROUTE_NAME.QUESTIONS_TWO,
      component: Two,
    },
    {
      path: PATH.QUESTIONS_THREE,
      name: ROUTE_NAME.QUESTIONS_THREE,
      component: Three,
    },
    {
      path: PATH.QUESTIONS_FOUR,
      name: ROUTE_NAME.QUESTIONS_FOUR,
      component: Four,
    },
    {
      path: PATH.QUESTIONS_FIVE,
      name: ROUTE_NAME.QUESTIONS_FIVE,
      component: Five,
    },
    {
      path: PATH.QUESTIONS_RESULT,
      name: ROUTE_NAME.QUESTIONS_RESULT,
      component: Result,
    },
  ],
})
